import { render, staticRenderFns } from "./addImgBlog.vue?vue&type=template&id=777fdbfa&scoped=true&"
import script from "./addImgBlog.vue?vue&type=script&lang=js&"
export * from "./addImgBlog.vue?vue&type=script&lang=js&"
import style0 from "./addImgBlog.vue?vue&type=style&index=0&id=777fdbfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777fdbfa",
  null
  
)

export default component.exports